import { ModalState } from 'ia-react-core/~/interfaces/ModalState';
import { ModalAction } from 'ia-react-core/~/interfaces/ModalAction';
import OpenModalById from 'ia-react-core/~/actions/modal/OpenModalById';
import get from '../../../utils/accessors/get';
import mergeState from '../../../utils/accessors/_mergeState';
import set from '../../../utils/accessors/set';

import openModalById from '../../../actions/modal-fn/openModalById';
import closeModalById from '../../../actions/modal-fn/closeModalById';
import closeAllModals from '../../../actions/modal-fn/closeAllModals';
import openModalByName from '../../../actions/modal-fn/openModalByName';
import closeModalByName from '../../../actions/modal-fn/closeModalByName';

export default function modalReducer(state: ModalState, action: ModalAction) {
  const modalId = get(state, 'modalId');
  const name = get(state, 'name');

  switch (action.type) {
    case `${openModalById.type}/${modalId}`:
    case `${openModalByName.type}/${name}`:
      return reduceOpenModal(state, action as OpenModalById);
    case `${closeModalById.type}/${modalId}`:
    case `${closeModalByName.type}/${name}`:
    case closeAllModals.type:
      return reduceCloseModal(state);
    default:
      return state;
  }
}

function reduceOpenModal(state: ModalState, action: OpenModalById) {
  return mergeState(state, {
    isOpened: true,
    data: action.data,
  }, { mergeBlacklist: [action.data] }) as ModalState;
}

function reduceCloseModal(state: ModalState) {
  return set(state, 'isOpened', false);
}
